import { MatchPaymentInfo } from "@app/core/match/domain/model/match-payment-info";

export class MatchPaymentInfoMapper {
  static deserialize(response: any): MatchPaymentInfo {
    return {
      club_id: response.club_id,
      court_id: response.court_id,
      address: response.address,
      match_id: response.id,
      reservation_id: response.match_request,
      club: response.club,
      court: response.pista,
      location: response.location,
      date: response.fecha,
      hour_from: response.hora_from.slice(0, response.hora_from.length - 3),
      hour_to: response.hora_to.slice(0, response.hora_to.length - 3),
      url_payment: response.url_payment,
      payment_done: response.payment_done,
      email1: response.email1 == "empty_user1@gmail.com" ? "" : response.email1,
      email2: response.email2 == "empty_user2@gmail.com" ? "" : response.email2,
      email3: response.email3 == "empty_user3@gmail.com" ? "" : response.email3,
      email4: response.email4 == "empty_user4@gmail.com" ? "" : response.email4,
      name1: response.name1 == "Empty User" ? "" : response.name1,
      name2: response.name2 == "Empty User" ? "" : response.name2,
      name3: response.name3 == "Empty User" ? "" : response.name3,
      name4: response.name4 == "Empty User" ? "" : response.name4,
      picture1: response.picture1,
      picture2: response.picture2,
      picture3: response.picture3,
      picture4: response.picture4,
      is_some_payment_done: response.is_some_payment_done,
      google_maps_link: response.google_maps_link,
      has_person1_paid: response?.payments_complete_list.some(
        (i: any) => i["user_email"] === response.email1
      ),
      has_person2_paid: response?.payments_complete_list.some(
        (i: any) => i["user_email"] === response.email2
      ),
      has_person3_paid: response?.payments_complete_list.some(
        (i: any) => i["user_email"] === response.email3
      ),
      has_person4_paid: response?.payments_complete_list.some(
        (i: any) => i["user_email"] === response.email4
      ),
      duration: response.duration,
      competitive: response.competitive ?? null,
      transactions: response.transactions,
    };
  }
}
